var render = function render(){var _vm=this,_c=_vm._self._c;return _c('picture',{style:({ fontSize: `${_vm.size}px` }),attrs:{"title":_vm.title}},[_c('span',[_c('b-icon',{attrs:{"icon":_vm.icon,"size":"is-small"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }